export default __webpack_public_path__ + "static/media/PhonePe.de309af2.svg";